import React, { useEffect, useRef, useState } from 'react';
import './WelfareSignatures.css';

// A welfare report's photo, video or PDF. `load` fetches the file as a blob
// (staff and recipients of a shared report fetch it from different places);
// `onDelete` adds a Remove button.
export default function AttachmentTile({ attachment, load, onDelete }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [loadError, setLoadError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const loadRef = useRef(load);
  loadRef.current = load;
  const isVideo = attachment.mimeType?.startsWith('video/');
  const isPdf = attachment.mimeType === 'application/pdf';

  useEffect(() => {
    let cancelled = false;
    let url = null;
    setLoadError(false);
    loadRef.current()
      .then(res => {
        if (cancelled) return;
        url = URL.createObjectURL(res.data);
        setBlobUrl(url);
      })
      .catch(() => !cancelled && setLoadError(true));
    return () => { cancelled = true; if (url) URL.revokeObjectURL(url); };
  }, [attachment.id, attempt]);

  const sizeStr = attachment.fileSize > 1024 * 1024
    ? `${(attachment.fileSize / (1024 * 1024)).toFixed(1)} MB`
    : `${Math.max(1, Math.round(attachment.fileSize / 1024))} KB`;

  return (
    <div className="wfile">
      {loadError && (
        <div className="wfile__box" role="alert">
          Couldn't load
          <button type="button" className="bk-btn bk-btn--sm" onClick={() => setAttempt(a => a + 1)}>Try again</button>
        </div>
      )}
      {!loadError && !blobUrl && <div className="wfile__box" role="status">Loading…</div>}
      {!loadError && blobUrl && isPdf && (
        <a href={blobUrl} target="_blank" rel="noopener noreferrer" className="wfile__box">
          <span className="wfile__pdf">PDF</span>
          Open
        </a>
      )}
      {!loadError && blobUrl && !isVideo && !isPdf && (
        <img src={blobUrl} alt={attachment.fileName} className="wfile__img" />
      )}
      {!loadError && blobUrl && isVideo && (
        <video src={blobUrl} controls preload="metadata" className="wfile__video" />
      )}
      <div>
        <div className="wfile__name" title={attachment.fileName}>{attachment.fileName}</div>
        <div className="wfile__meta">
          {sizeStr}{attachment.uploadedBy && ` · ${attachment.uploadedBy.firstName} ${attachment.uploadedBy.lastName}`}
        </div>
      </div>
      {onDelete && (
        <button type="button" className="bk-btn bk-btn--sm bk-btn--outline-danger" onClick={onDelete}>
          Remove
        </button>
      )}
    </div>
  );
}
